<h2 mat-dialog-title i18n="Header of popup">File downloaded</h2>
<mat-dialog-content class="content">
  <button
    mat-stroked-button
    (click)="showFile()"
    i18n="Button to show a downloaded file"
  >
    Show File
  </button>
  <p>
    <em i18n="Text in popup"
      >To automatically open files after they have been downloaded, please allow
      popups for this page in your browser.</em
    >
  </p>
</mat-dialog-content>
